<template>
  <div >
    測試功能頁
  </div>
</template>

<script>

export default {
  // 測試功能頁
  name: 'Test',
  data() {
    return {
     
    };
  },
  async created() {


  },
  mounted() {
  },
  methods: {
  
  }
}
</script>